// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { BetslipDisplayStatuses } from '../../../../types/betslip';
import type { BetslipDisplayStatus } from '../../../../types/betslip';

const Wrap = styled.p`
  margin: 0;

  background: ${({ $status, theme }) => {
    if ($status === BetslipDisplayStatuses.WINNING) {
      return theme.grids.colors.greenwin;
    }
    if ($status === BetslipDisplayStatuses.LOST) {
      return theme.grids.gradients.red();
    }
    if ($status === BetslipDisplayStatuses.RUNNING) {
      return theme.grids.colors.yellow;
    }
    if ($status === BetslipDisplayStatuses.CANCELLED) {
      return theme.grids.colors.middlegrey2;
    }
    return '#fff';
  }};
  color: ${({ $status, theme }) => {
    switch ($status) {
      case BetslipDisplayStatuses.WINNING:
      case BetslipDisplayStatuses.RUNNING:
        return theme.grids.colors.grey;
      case BetslipDisplayStatuses.LOST:
        return '#fff';
      case BetslipDisplayStatuses.CANCELLED:
        return theme.grids.colors.black;
      default:
        return theme.grids.colors.grey;
    }
  }};
`;

type Props = {
  className?: string;
  status: BetslipDisplayStatus;
  statusLabel: string;
};

const GridStatus = ({ className, status, statusLabel }: Props) => {
  return (
    <Wrap className={className} $status={status}>
      {statusLabel}
    </Wrap>
  );
};

export default GridStatus;
